import { render, staticRenderFns } from "./ProfesorAlumnos.vue?vue&type=template&id=2ded41d6&"
import script from "./ProfesorAlumnos.vue?vue&type=script&lang=js&"
export * from "./ProfesorAlumnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports